import { Box, Button, styled } from '@mui/material';

const MainContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0,
  flex: 1,
  minWidth: 0,
}));

const ViewsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: '1 1 auto',
  minWidth: 0,
  paddingBottom: '12px',
  marginBottom: '-8px',
  scrollbarWidth: 'thin',
  scrollbarGutter: 'stable',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ccc',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#aaa',
    },
  },
}));

const ViewButtonContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
  marginLeft: '8px',
  '&:first-of-type': {
    marginLeft: 0,
  },
}));

const StyledViewButton = styled(Button)<{ isActive?: boolean }>(({ isActive, theme }) => ({
  maxWidth: '220px',
  minWidth: 'auto',
  textTransform: 'none',
  backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
  color: isActive ? theme.palette.common.white : theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: isActive ? theme.palette.primary.dark : theme.palette.action.hover,
  },
  '& .button-text': {
    display: 'block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export { MainContainer, ViewsContainer, ViewButtonContainer, StyledViewButton };

